/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-events',
    'window'
],
function(
    pip,
    pipEvents,
    window
){

	function initEventListeners(){

		pipEvents.expressDelivery.expressDeliveryError.on('.expressDeliveryError', function(evtType, data){
			pushAnalyticsErrorEvent(data);
		});

	}

	function pushAnalyticsErrorEvent(error){
        var analyticsObj = {
            category: {
                primaryCategory: 'error'
            },
            eventInfo: {
                eventName: 'post page error',
                error: [error]
            }
        };

		if (pip.debugMode) console.log('DDO BODFS Error Event', analyticsObj);
		if(window.digitalData && window.digitalData.event) window.digitalData.event.push(analyticsObj);

	}

	return {
		init: function(){
			initEventListeners();
		}
	}

});

}.call(window));